module.exports = __webpack_public_path__ + "static/media/FI.a5471749.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/FI.svg
// module id = 2149
// module chunks = 7